'use client'

import React from 'react'
import { useRouter } from 'next/navigation'

import { ArrowLeftIcon } from '@modules/common/icons'

type Props = {
  className?: string
}

const BackOverlayButton: React.FC<Props> = ({ className }) => {
  const router = useRouter()

  return (
    <button
      type="button"
      aria-label="Back"
      onClick={() => router.back()}
      className={
        'flex h-10 w-10 items-center justify-center rounded-full bg-black/50 text-white transition hover:bg-black/70 ' +
        (className ? className : '')
      }
    >
      <ArrowLeftIcon color="#fff" width={20} height={20} />
    </button>
  )
}

export default BackOverlayButton
